import { useLocalStorage } from '@mantine/hooks'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { cx } from 'src/utils/cx'
import { track } from 'src/utils/tracker'
import IcBaselineClose from '~icons/ic/baseline-close'
import IcRoundWarning from '~icons/ic/round-warning'
import { useEmailVerificationStatus } from './useForceVerifyEmail'

export function EmailVerifyBanner({ className }: { className?: string }) {
  const { isEmailVerificationWarning } = useEmailVerificationStatus()
  const { t } = useTranslation(['generation', 'user', 'action'])
  const [dismissed, setDismissed] = useLocalStorage({
    key: 'force-verify-email::banner-dismissed',
    defaultValue: false,
    getInitialValueInEffect: false,
  })

  if (!isEmailVerificationWarning || dismissed) {
    return null
  }

  return (
    <div
      className={cx(
        'p-2 leading-5 flex items-center rounded-md select-none',
        'bg-amber-100 dark:bg-amber-500/10 text-amber-600 dark:text-amber-500',
        className,
      )}
    >
      <IcRoundWarning className="flex-none w-5 h-5 inline-block mr-1" />
      <span className="text-sm flex-1">
        {t('generation:tips.verify-email-short')}
      </span>
      <div className="flex items-center gap-2 flex-none">
        <Link
          to="/profile/edit/accounts"
          className="px-3 py-1 rounded-md bg-amber-500 text-white hover:bg-amber-600 text-sm whitespace-nowrap"
          onClick={() => {
            track('email_verify_banner_verify_now_click')
          }}
        >
          {t('user:profile.verify-now-short')}
        </Link>
        <button
          className="p-1 rounded-md hover:bg-amber-200 dark:hover:bg-amber-800 transition-colors"
          onClick={() => {
            track('email_verify_banner_close_click')
            setDismissed(true)
          }}
          aria-label={t('action:close')}
        >
          <IcBaselineClose className="size-4" />
        </button>
      </div>
    </div>
  )
}
